import type { FC, PropsWithChildren } from 'react';

import styles from './ErrorMessage.module.scss';

export const ErrorMessage: FC<PropsWithChildren<{ className?: string; noSpaceWhenEmpty?: boolean }>> = ({
  className,
  noSpaceWhenEmpty,
  children,
}) =>
  children || !noSpaceWhenEmpty ? (
    <div className={`animation-slide-down ${styles.errorMessage} ${className}`}>{children || <>&nbsp;</>}</div>
  ) : null;
